"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllCompany = getAllCompany;
exports.getPortContacts = getPortContacts;
var _request = _interopRequireDefault(require("@/utils/request"));
//获取航运集团下的所有公司
function getAllCompany(id) {
  return (0, _request.default)({
    url: '/equery/sysPortContact/shippingCompany/' + id,
    method: 'get'
  });
}

//根据公司，查询出对应的联系方式
function getPortContacts(id) {
  return (0, _request.default)({
    url: '/equery/sysPortContact/findByDeptId/' + id,
    method: 'get'
  });
}